import React, { Component } from 'react';

import Container from 'components/container';
import LoginForm from './LoginForm';
import OnboardingStore from 'modules/onboarding/OnboardingStore';

import './LoginPage.css';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.loginState = OnboardingStore.getLoginState();
    }

    componentWillMount = () => {
        OnboardingStore.on('change', this.onLoginStateChange);
    };

    componentWillUnmount = () => {
        OnboardingStore.removeListener('change', this.onLoginStateChange);
    };

    onLoginStateChange = () => {
        const loginState = OnboardingStore.getLoginState();
        console.log('onLoginStateChange', {
            loginState
        });
        if (loginState.failed) {
            alert('Your email or password is incorrect.');
        }
        this.setState({ loginState });
    };

    render() {
        return (
            <div className="login-page page">
                <Container transparent fluid>
                    <div className="login-form-wrapper">
                        <LoginForm loginState={this.state.loginState} />
                    </div>
                </Container>
            </div>
        );
    }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/login/LoginPage.jsx